module.exports = __webpack_public_path__ + "img/icon_location.5837dad3.svg";